import { render, staticRenderFns } from "./InspectionTransfers.vue?vue&type=template&id=382cd3f8&scoped=true&"
import script from "./InspectionTransfers.vue?vue&type=script&lang=ts&"
export * from "./InspectionTransfers.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionTransfers.vue?vue&type=style&index=0&id=382cd3f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382cd3f8",
  null
  
)

export default component.exports